import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { HeaderStyled, HeaderContent, LanguagesWrapper, CurrentLanguage, Languages, Language, RightPanel, Logout, Logo, StyledVersion } from './styled'
import { Store } from '../../context/store'
import Icon from "../../components/Icon"
import Container from '../../components/Container';
import { PoseGroup } from 'react-pose';
import SearchCow from '../SearchCow';

const Header = React.memo(({ withLangSwitcher }) => {
  const { state, actions } = Store()
  const { i18n } = useTranslation()
  const [open, setOpen] = useState(false)

  const changeLanguage = lng => {
    i18n.changeLanguage(lng)
    setOpen(false)
  }

  const logout = () => {
    actions.setLoginFailure()
  }

  return (
    <HeaderStyled>
      <Container>
        <HeaderContent>
          <Logo to="/">
            <Icon name='logo' />
            <StyledVersion>
              {process.env.REACT_APP_VERSION}
            </StyledVersion>
          </Logo>
          <RightPanel>
            {
              withLangSwitcher &&
              <LanguagesWrapper>
                <CurrentLanguage
                  onClick={() => setOpen(!open)}
                >
                  {i18n.language}
                </CurrentLanguage>
                <PoseGroup>
                  {
                    open &&
                    <Languages
                      key="lang"
                    >
                      {
                        i18n.languages
                          .filter(lang => lang !== i18n.language)
                          .map(lang => (
                            <Language
                              key={lang}
                              onClick={() => changeLanguage(lang)}
                            >
                              {lang}
                            </Language>
                          ))
                      }
                    </Languages>
                  }
                </PoseGroup>
              </LanguagesWrapper>
            }
            {
              state.user &&
              <>
                <SearchCow />
                <Logout onClick={logout}>
                  <Icon name="logout" />
                </Logout>
              </>
            }
          </RightPanel>
        </HeaderContent>
      </Container>
    </HeaderStyled>
  )
})

export default Header
